import React from "react";
import PropTypes from "prop-types";
import MembershipHelpers from "helpers/membership-helpers";
import { productPropType } from "components/propTypes";
import AtomRetailPrice from "./atom-retail-price";
import { withShowTooltipOnLoad } from "components/source/shared/with-show-tooltip-on-load";
import RecommendedFitTag from "components/source/new_taxonomy/recommended-fit-tag";
export const RetailPriceWithTooltip = withShowTooltipOnLoad("Drawer")(AtomRetailPrice);

export default class AtomProductCardTitleInfoComponent extends React.Component {
  static propTypes = {
    annotationSuffix: PropTypes.string,
    hidePrice: PropTypes.bool,
    membershipPricing: PropTypes.array,
    product: productPropType,
    showPurchasePrice: PropTypes.bool,
    userData: PropTypes.object,
  };

  static defaultProps = {
    showPurchasePrice: true,
  };

  // if we are not rendering other prices, why would we render annotations?
  renderAnnotation() {
    if (this.props.hidePrice) return;

    if (this.props.showPurchasePrice) return;

    if (MembershipHelpers.isSubscriptionLens(this.props.userData)) {
      const discount = MembershipHelpers.getDiscountObject(this.props.product?.price, this.props.membershipPricing);
      const discountPdpAnnotation = discount?.pdp;
      let annotationText;

      if (discountPdpAnnotation) {
        annotationText = discountPdpAnnotation.annotation;
      }

      if (this.props.annotationSuffix) {
        annotationText += this.props.annotationSuffix;
      }

      if (!annotationText) return;

      return <p className="universal-medium product-card-title-info__annotation">{annotationText}</p>;
    }
  }

  renderRetailPrice() {
    if (this.props.hidePrice) return;

    const {
      product: {
        designer: { id: designerId } = {},
        retailPrice,
        retailPriceFormatted,
        purchasePriceDiscountFromRetailPrice,
      } = {},
    } = this.props;

    if (!retailPriceFormatted) return;

    const className = "retail universal-medium pricing-divider";
    return (
      <RetailPriceWithTooltip
        className={className}
        designerId={designerId}
        priceClassName="universal-medium--secondary"
        purchasePriceDiscountFromRetailPrice={purchasePriceDiscountFromRetailPrice}
        retailPrice={retailPrice}
        retailPriceFormatted={retailPriceFormatted}
        showPurchasePriceDiscount={false}
        showPurchasePriceTooltip={true}
      />
    );
  }

  render() {
    const { product, userData } = this.props;
    const baseClass = "product-card-title-info";
    const annotation = this.renderAnnotation();
    if (!product) {
      return <div className="product-card-title-info__no-product"></div>;
    }

    return (
      <section className={baseClass}>
        {product.designer && (
          <h3 className="product-card-title-info__designer-name">
            <a
              className="universal-xlarge--semibold"
              href={"/designers/" + product.designer.id + "?source=product_drawer"}>
              {product.designer.displayName}
            </a>
          </h3>
        )}
        <h5 className="universal-medium product-card-title-info__style-name">{product.displayName}</h5>
        <div>
          <RecommendedFitTag product={product} userData={userData} />
        </div>
        {this.renderRetailPrice()}
        {annotation}
      </section>
    );
  }
}
